<script setup>
import Heading from '@/Components/Heading.vue';
import Logo from '@/Components/Logo.vue';
import Button from '@/Components/Button.vue';
import Icon from '@/Components/Icon/index.vue';
import { usePage } from '@inertiajs/vue3';
import { ref, onMounted, computed } from 'vue';
import { THEMES } from '@/constants';
import { previousRoute } from '@/composables/useNavigationTracker';

const props = defineProps({
  imageSet: {
    type: Object,
    required: false
  },
  logoAltText: {
    type: String,
    required: false,
  },
});

const page = usePage();
const context = computed(() => page.props?.context);
const theme = context.value.theme;

// Could use `Back to ${page.props.history.previousRouteName}`
const goBackLabel = ref('Back');

const goBack = () => {
  if (previousRoute.value) {
    history.back();
  } else {
    window.location.href = context.value.home_url;
  }
}

const hrClasses = computed(() => [
  'w-full my-6',
  theme == THEMES.STUDY_MELB && 'invisible',
]);
</script>

<template>
  <div>
    <Button variant="link" class="inline-flex items-center my-3" @click="goBack">
      <Icon path="ChevronLeft" :height="20" :width=20 class="inline-block"/>{{ goBackLabel }}</Button>
    <div class="md:flex">
      <div
        v-if="imageSet"
        class="me-6"
      >
        <Logo
          size="lg"
          :image-set="imageSet"
          :alt-text="logoAltText"
        />
      </div>
      <div>
        <div>
          <Heading
            size="h1"
            style-size="h1"
            class="mt-0 mb-2"
          >
            <slot name="title" />
          </Heading>
          <Heading
            size="h2"
            style-size="h3"
            class="mb-4 font-bold text-link"
          >
            <slot name="subtitle" />
          </Heading>
        </div>
        <div>
          <ul class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-1">
            <slot name="actions" />
          </ul>
        </div>
      </div>
    </div>
    <hr :class="hrClasses">
  </div>
</template>
